<template>
  <div>
    <b-dropdown
      v-model="selectedFont"
      aria-role="list"
      class="font-selector"
    >
      <template #trigger>
        <slot />
      </template>
      <b-dropdown-item
        v-for="(font, fIndex) in fontList"
        :key="'font-type' + fIndex"
        :value="font"
        aria-role="listitem"
      >
        <span>{{ font }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script >
import { computed, ref } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  value: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const fontList = ref(['Default', 'Arial', 'Courier New', 'Georgia', 'Helvetica', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana']);
  const selectedFont = computed({
    get() {
      return props.value ? props.value.split(', ')[0] : 'Default';
    },
    set(value) {
      value = value === 'Default' ? '' : `${value}, sans-serif`;
      emit('input', value);
    }
  });
  return {
    fontList,
    selectedFont
  };
};
export default __sfc_main;
</script>

<style lang="scss">
.font-selector {
  .dropdown-menu {
    z-index: 2000;
  }
}
</style>
